import { lazy } from "react";

const CreateEdit = lazy(() =>
  import("../../pages/UserAccess/AccessProfile/create-edit"),
);

const routes = [
  {
    path: "/access_profile",
    element: lazy(() =>
      import("../../pages/UserAccess/AccessProfile/index"),
    ),
  },
  {
    path: "/access_profile/add",
    element: CreateEdit,
  },
  {
    path: "/access_profile/edit/:id",
    element: CreateEdit,
  },
];

export default routes;
